import { useMemo, useState } from 'react';
import {
  getPaymentMethodDetails,
  removePaymentMethod
} from 'src/api/card';
import { CardContext, PaymentMethod } from './card-context-types';

interface CardProviderProps {
  children: React.ReactNode;
}

const CardProvider: React.FC<CardProviderProps> = ({ children }) => {
  const [paymentMethods, setPaymentMethods] = useState<PaymentMethod[]>();
  const [selectedCard, setCard] = useState<PaymentMethod | null>(null);

  const providerValue = useMemo(() => {
    const fetchCardDetails = (id: string) => {
      getPaymentMethodDetails(id).then((res) => {
        if (res.success) {
          setPaymentMethods(res.data as PaymentMethod[]);
        }
      });
    };

    const setPrimaryCard = (card: PaymentMethod) => {
      setCard(card);
    };

    const removeCardDetails = (id: string) => {
      removePaymentMethod(id).then((res) => {
        if (res.success) {
          setPaymentMethods((prevMethods) =>
            prevMethods?.filter((method) => method.id !== id)
          );
          setCard(null);
        }
      });
    };

    return {
      paymentMethods,
      selectedCard,
      setPrimaryCard,
      fetchCardDetails,
      removeCardDetails,
    };
  }, [paymentMethods, selectedCard]);

  return (
    <CardContext.Provider value={providerValue}>{children}</CardContext.Provider>
  );
};

export default CardProvider;
